import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/Table.css';

import { BrowserRouter, Routes, Route, Navigate, useRoutes } from 'react-router-dom';
import {routesConfig} from "./RouteConfig";

const AppRoutes = () => {
    return useRoutes(routesConfig);
};

function App() {
    return (
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
            );
}

export default App

